module.exports = __webpack_public_path__ + "static/media/contact.f0b8301c.svg";